import { PortModel } from 'storm-react-diagrams';
import { Point, PortSide } from '../types';
import { default as BaseLinkModel } from './BaseLinkModel';

export default class BasePortModel extends PortModel {
  links: Partial<Record<PortSide, BaseLinkModel>> = {};
  unitVector!: Point;

  constructor(name: PortSide) {
    super(name);
  }

  /**
   * No need to return anything for port
   * Significant speed up for diagram serialization
   */
  serialize(): any {
    return null;
  }
}
